module.exports = __webpack_public_path__ + "static/media/btn_alien_active.3a25cf9c.png";